import { ChangeEvent, useMemo } from 'react';
import useTextInput, { ValidationLogic } from './useTextInput';
import i18n from '../../R/string/i18n';

const emailValidationLogics = (): ValidationLogic[] => [
  {
    logic: (email: string) => email.length <= 0,
    msg: i18n.formEmailIsRequired()
  },
  {
    logic: (email: string) =>
      !/^([a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/.test(
        email
      ),
    msg: i18n.formEmailIsWrongFormat()
  }
];

function useEmailInput(
  initVal: string
): [
  string,
  (e: ChangeEvent<HTMLInputElement>) => void,
  string | undefined,
  React.Dispatch<React.SetStateAction<string>>,
  boolean,
  React.Dispatch<React.SetStateAction<boolean>>
] {
  const validationLogicsTranslated = emailValidationLogics();

  const [email, onChangeEmail, emailErr, setEmail, setNotTouched] =
    useTextInput(initVal, validationLogicsTranslated, 1000);

  const hasError = useMemo(
    () => validationLogicsTranslated.some(({ logic }) => logic(email)),
    [email]
  );

  return [email, onChangeEmail, emailErr, setEmail, hasError, setNotTouched];
}

export default useEmailInput;
